import Long from "long";
import _m0 from "protobufjs/minimal";
import { ConfigTargetingAppState } from "./config_request";
export const protobufPackage = "snapchat.cdp.cof";
export interface BoltSignals {
    boltUseCase: number;
    boltCdnExperimentationId: number;
    boltIsContentPopular: boolean;
    boltClientAppState: ConfigTargetingAppState;
}
function createBaseBoltSignals(): BoltSignals {
    return { boltUseCase: 0, boltCdnExperimentationId: 0, boltIsContentPopular: false, boltClientAppState: 0 };
}
export const BoltSignals = {
    encode(message: BoltSignals, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
        if (message.boltUseCase !== 0) {
            writer.uint32(8).uint32(message.boltUseCase);
        }
        if (message.boltCdnExperimentationId !== 0) {
            writer.uint32(16).uint32(message.boltCdnExperimentationId);
        }
        if (message.boltIsContentPopular === true) {
            writer.uint32(24).bool(message.boltIsContentPopular);
        }
        if (message.boltClientAppState !== 0) {
            writer.uint32(32).int32(message.boltClientAppState);
        }
        return writer;
    },
    decode(input: _m0.Reader | Uint8Array, length?: number): BoltSignals {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBoltSignals();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.boltUseCase = reader.uint32();
                    break;
                case 2:
                    message.boltCdnExperimentationId = reader.uint32();
                    break;
                case 3:
                    message.boltIsContentPopular = reader.bool();
                    break;
                case 4:
                    message.boltClientAppState = reader.int32() as any;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial<I extends Exact<DeepPartial<BoltSignals>, I>>(object: I): BoltSignals {
        const message = createBaseBoltSignals();
        message.boltUseCase = object.boltUseCase ?? 0;
        message.boltCdnExperimentationId = object.boltCdnExperimentationId ?? 0;
        message.boltIsContentPopular = object.boltIsContentPopular ?? false;
        message.boltClientAppState = object.boltClientAppState ?? 0;
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & Record<Exclude<keyof I, KeysOfUnion<P>>, never>;
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long as any;
    _m0.configure();
}
